import { useRef, useState } from 'react'
import type { FormEvent } from 'react'
import { postSignup } from './signup'

type Status = 'idle' | 'loading' | 'success' | 'error'

// Short sign-up right under the big headline. Same confirmed-only save as the footer form.
export default function QuickSignup({ preview }: { preview: boolean }) {
  const [email, setEmail] = useState('')
  const [website, setWebsite] = useState('')
  const [source, setSource] = useState('')
  const [status, setStatus] = useState<Status>('idle')
  const sending = useRef(false)

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (sending.current || status === 'success' || !email.trim()) return
    if (preview) {
      setStatus('success')
      return
    }
    sending.current = true
    setStatus('loading')
    try {
      await postSignup('beta', email.trim(), website, source)
      setStatus('success')
      setEmail('')
    } catch {
      setStatus('error')
    } finally {
      sending.current = false
    }
  }

  if (status === 'success') {
    return <p className="qs-done" role="status">You're on the list. We'll email you before the Steam beta opens.</p>
  }

  return (
    <form className="qs" onSubmit={submit} aria-label="Get an early seat for the Steam beta">
      <label className="sr-only" htmlFor="qs-email">Your email address</label>
      <input id="qs-email" type="email" required maxLength={254} autoComplete="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} disabled={status === 'loading'} />
      <div className="honeypot" aria-hidden="true"><label htmlFor="qs-website">Leave this field empty</label><input id="qs-website" value={website} onChange={e => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off" /></div>
      <select className="qs-source" value={source} onChange={e => setSource(e.target.value)} aria-label="How did you hear about us? (optional)">
        <option value="">How did you hear about us?</option>
        <option value="x">X (Twitter)</option>
        <option value="instagram">Instagram</option>
        <option value="tiktok">TikTok</option>
        <option value="friend">A friend</option>
        <option value="google">Google</option>
        <option value="steam">Steam</option>
        <option value="other">Somewhere else</option>
      </select>
      <button type="submit" disabled={status === 'loading'}>{status === 'loading' ? 'Saving…' : 'Get an early seat'}</button>
      {status === 'error' && <p className="qs-error" role="status">Could not save. Please try again.</p>}
      <small>Only for the game beta and launch news. No spam.</small>
    </form>
  )
}
